/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-8c8a3203.js';
import { _ as _slicedToArray } from '../_chunks/dep-605e961c.js';
import React, { useState, useContext, useMemo, useRef } from 'react';
import classNames from 'classnames';
import useConfig from '../hooks/useConfig.js';
import { MenuContext } from './MenuContext.js';
import useDomRefCallback from '../hooks/useDomRefCallback.js';
import useRipple from '../_util/useRipple.js';
import { getSubMenuMaxHeight } from './_util/getSubMenuChildStyle.js';
import checkSubMenuChildrenActive from './_util/checkSubMenuChildrenActive.js';
import FakeArrow from '../common/FakeArrow.js';
import { checkIsSubMenu, checkIsMenuGroup } from './_util/checkMenuType.js';
import { cacularPaddingLeft } from './_util/cacularPaddingLeft.js';
import '../_chunks/dep-f66447d3.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-1d5f47c2.js';
import '../_chunks/dep-8670d51c.js';
import '../_chunks/dep-df9f8f04.js';
import '../_chunks/dep-9d326786.js';
import '../_chunks/dep-3542b5f1.js';
import '../_chunks/dep-79aca757.js';
import '../_chunks/dep-c7d784af.js';
import '../_chunks/dep-2055661d.js';
import '../_chunks/dep-73c3cd54.js';
import '../_chunks/dep-ced835e2.js';
import '../_chunks/dep-1e76a561.js';
import '../_chunks/dep-6b33e1e9.js';
import '../_chunks/dep-dae4a585.js';
import '../_chunks/dep-9e05eaf2.js';
import '../_chunks/dep-0d617aaa.js';
import '../_chunks/dep-030d278c.js';
import '../_chunks/dep-868937ef.js';
import '../_chunks/dep-6f5c07a7.js';
import '../_chunks/dep-a79a1775.js';
import '../_chunks/dep-7b744c82.js';
import '../_chunks/dep-0b20126b.js';
import '../_chunks/dep-2b7035c1.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-4fce6f2f.js';
import '../_common/js/global-config/default-config.js';
import '../_util/noop.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-378695bd.js';
import '../_util/easing.js';
import './_util/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SubAccordion = function SubAccordion(props) {
  var _classNames, _classNames2;
  var content = props.content,
    _props$children = props.children,
    children = _props$children === void 0 ? content : _props$children,
    disabled = props.disabled,
    icon = props.icon,
    title = props.title,
    value = props.value,
    className = props.className,
    style = props.style,
    _props$level = props.level,
    level = _props$level === void 0 ? 1 : _props$level;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useContext = useContext(MenuContext),
    _useContext$expanded = _useContext.expanded,
    expanded = _useContext$expanded === void 0 ? [] : _useContext$expanded,
    onExpand = _useContext.onExpand,
    active = _useContext.active,
    expandType = _useContext.expandType;
  var isPopUp = expandType === "popup";
  var isExpand = expanded.includes(value) && !disabled && !isPopUp;
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    onExpand(value, expanded);
  };
  var handleMouseEvent = function handleMouseEvent(type) {
    if (!isPopUp) return;
    if (type === "enter") setOpen(true);else if (type === "leave") setOpen(false);
  };
  var childrens = React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      className: classNames("".concat(classPrefix, "-menu__item--plain"), "".concat(classPrefix, "-submenu__item"), "".concat(classPrefix, "-submenu__item--icon"))
    });
  });
  var childStyle = {
    maxHeight: isExpand || open && isPopUp ? getSubMenuMaxHeight(children) : 0
  };
  var isOpen = useMemo(function () {
    if (disabled) return false;
    if (isPopUp) return open;
    return isExpand;
  }, [disabled, isPopUp, open, isExpand]);
  var menuPaddingLeft = cacularPaddingLeft(level - 1);
  var fakeArrowStyle = isPopUp && level > 1 ? {
    transform: "rotate(-90deg)"
  } : {};
  return /* @__PURE__ */React.createElement("li", {
    className: classNames("".concat(classPrefix, "-submenu"), className, (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-is-disabled"), disabled), _defineProperty(_classNames, "".concat(classPrefix, "-is-opened"), isOpen), _classNames)),
    onClick: handleClick,
    style: style,
    onMouseEnter: function onMouseEnter() {
      return handleMouseEvent("enter");
    },
    onMouseLeave: function onMouseLeave() {
      return handleMouseEvent("leave");
    }
  }, /* @__PURE__ */React.createElement("div", {
    className: classNames("".concat(classPrefix, "-menu__item"), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(classPrefix, "-is-opened"), isOpen), _defineProperty(_classNames2, "".concat(classPrefix, "-is-active"), checkSubMenuChildrenActive(children, active)), _classNames2))
  }, icon, " ", /* @__PURE__ */React.createElement("span", {
    className: "".concat(classPrefix, "-menu__content")
  }, title), /* @__PURE__ */React.createElement(FakeArrow, {
    style: fakeArrowStyle,
    isActive: level === 1 && isOpen,
    disabled: disabled
  })), isPopUp ? /* @__PURE__ */React.createElement("div", {
    className: classNames("".concat(classPrefix, "-menu__popup"), "".concat(classPrefix, "-is-vertical"), _defineProperty({}, "".concat(classPrefix, "-is-opened"), isOpen))
  }, /* @__PURE__ */React.createElement("ul", {
    className: classNames("".concat(classPrefix, "-menu__popup-wrapper"), _defineProperty({}, "".concat(classPrefix, "-is-opened"), isOpen)),
    key: "popup",
    style: childStyle
  }, childrens)) : /* @__PURE__ */React.createElement("ul", {
    key: "normal",
    style: _objectSpread(_objectSpread({}, childStyle), {}, {
      "--padding-left": "".concat(menuPaddingLeft, "px")
    }),
    className: "".concat(classPrefix, "-menu__sub")
  }, childrens));
};
var SubTitleMenu = function SubTitleMenu(props) {
  var _popRef$current, _classNames6;
  var className = props.className,
    style = props.style,
    children = props.children,
    title = props.title,
    value = props.value,
    _props$level2 = props.level,
    level = _props$level2 === void 0 ? 1 : _props$level2;
  var _useContext2 = useContext(MenuContext),
    active = _useContext2.active,
    onChange = _useContext2.onChange,
    expandType = _useContext2.expandType;
  var _useConfig2 = useConfig(),
    classPrefix = _useConfig2.classPrefix;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var popRef = useRef();
  var handleClick = function handleClick() {
    return onChange(value);
  };
  var _useDomRefCallback = useDomRefCallback(),
    _useDomRefCallback2 = _slicedToArray(_useDomRefCallback, 2),
    subMenuDom = _useDomRefCallback2[0],
    setRefCurrent = _useDomRefCallback2[1];
  useRipple(subMenuDom);
  var isPopUp = expandType === "popup";
  var isActive = checkSubMenuChildrenActive(children, active) || active === value;
  var handleMouseEvent = function handleMouseEvent(type) {
    if (!isPopUp) return;
    if (type === "enter") setOpen(true);else if (type === "leave") setOpen(false);
  };
  var fakeArrowStyle = level > 1 ? {
    transform: "rotate(-90deg)"
  } : {};
  var submenuMaxHeight = getSubMenuMaxHeight(children);
  var popupMaxHeight = ((_popRef$current = popRef.current) === null || _popRef$current === void 0 ? void 0 : _popRef$current.getBoundingClientRect().height) || submenuMaxHeight;
  var showPopup = isPopUp && submenuMaxHeight > 0;
  return /* @__PURE__ */React.createElement("li", {
    className: classNames("".concat(classPrefix, "-submenu"), className, _defineProperty({}, "".concat(classPrefix, "-is-opened"), open)),
    onMouseEnter: function onMouseEnter() {
      return handleMouseEvent("enter");
    },
    onMouseLeave: function onMouseLeave() {
      return handleMouseEvent("leave");
    }
  }, /* @__PURE__ */React.createElement("div", {
    ref: setRefCurrent,
    className: classNames("".concat(classPrefix, "-menu__item"), (_classNames6 = {}, _defineProperty(_classNames6, "".concat(classPrefix, "-is-active"), isActive), _defineProperty(_classNames6, "".concat(classPrefix, "-is-opened"), open), _classNames6)),
    onClick: handleClick,
    style: style
  }, /* @__PURE__ */React.createElement("span", null, title), showPopup && /* @__PURE__ */React.createElement(FakeArrow, {
    style: fakeArrowStyle,
    isActive: level === 1 && open
  })), showPopup && /* @__PURE__ */React.createElement("div", {
    className: classNames("".concat(classPrefix, "-menu__popup"), _defineProperty({}, "".concat(classPrefix, "-is-opened"), open)),
    style: {
      "--popup-max-height": "".concat(popupMaxHeight, "px")
    }
  }, /* @__PURE__ */React.createElement("ul", {
    ref: popRef,
    className: classNames("".concat(classPrefix, "-menu__popup-wrapper"))
  }, children)));
};
var SubMenu = function SubMenu(props) {
  var _useContext3 = useContext(MenuContext),
    mode = _useContext3.mode;
  var children = props.children,
    _props$level3 = props.level,
    level = _props$level3 === void 0 ? 1 : _props$level3;
  var changeItemLevel = function changeItemLevel(item) {
    if (checkIsSubMenu(item)) {
      return /*#__PURE__*/React.cloneElement(item, {
        level: level + 1
      });
    }
    if (checkIsMenuGroup(item)) {
      var groupChildren = React.Children.map(item.props.children, function (item2) {
        return changeItemLevel(item2);
      });
      return /*#__PURE__*/React.cloneElement(item, {
        level: level + 1
      }, groupChildren);
    }
    return item;
  };
  var childElement = React.Children.map(children, function (item) {
    return changeItemLevel(item);
  });
  if (mode === "accordion") return /* @__PURE__ */React.createElement(SubAccordion, _objectSpread({}, props), childElement);
  if (mode === "title") return /* @__PURE__ */React.createElement(SubTitleMenu, _objectSpread({}, props), childElement);
  return null;
};
SubMenu.displayName = "SubMenu";

export { SubMenu as default };
//# sourceMappingURL=SubMenu.js.map
